import Icon from '../../components/Icon.vue'

Icon.register({"brands/speakap":{"width":448,"height":512,"paths":[{"d":"M352 32H96C43.2 32 0 75.2 0 128V384C0 436.8 43.2 480 96 480H352C404.8 480 448 436.8 448 384V128C448 75.2 404.8 32 352 32zM221 382.9C181.4 382.9 139.1 365.1 139.1 329.2V302H179V319.8C179 334.9 198.5 344.3 220.9 344.3 245.1 344.3 262.2 333.9 262.2 314.8 262.2 291 235 282.9 207.5 272.2 175.6 259.8 144.4 246 144.4 203.1 144.4 155.1 183 136.7 224.3 136.7 261.9 136.7 299.8 150.8 299.8 178.6V209.8H259.9V193.7C259.9 181.6 242.1 175.2 224.3 175.2 204.8 175.2 188.7 183.3 188.7 201.4 188.7 223.5 211.2 230.6 235.7 240.3 271.6 252.7 306.8 267.5 306.8 311.8 306.9 360.4 266 382.9 221 382.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/speakap.js
// module id = x6HL
// module chunks = 0